module.exports = __webpack_public_path__ + "static/media/min.5d369a95.png";